export enum SubscriptionPaymentPurpose {
  UPGRADE = 'UPGRADE',
  ADDON = 'ADDON',
}

export interface InitiateSubscriptionPaymentRequest {
  purpose: SubscriptionPaymentPurpose;
  planId?: string;
  billingCycle?: 'MONTHLY' | 'QUARTERLY' | 'YEARLY';
  addonId?: string;
}

export interface InitiateSubscriptionPaymentResponse {
  orderId: string;
  razorpayOrderId: string;
  razorpayKeyId: string;
  gatewayProvider: 'PLATFORM_RAZORPAY';
  paymentReceiver: 'PLATFORM';
  payAmount: number;
  currency: string;
  purpose: SubscriptionPaymentPurpose;
}

export interface ConfirmSubscriptionPaymentRequest {
  orderId: string;
  razorpayOrderId: string;
  razorpayPaymentId: string;
  razorpaySignature: string;
}

export interface ConfirmSubscriptionPaymentResponse {
  success: boolean;
  message: string;
  orderId: string;
  purpose: SubscriptionPaymentPurpose;
  payment: {
    transactionId: string;
    dateTime: string;
    paymentType: string;
    paymentMethod: string;
    paidAmount: number;
    customerBank: string | null;
  };
  invoiceId: string;
  receiptId: string | null;
  entitlements?: string[];
}

export type {
  RazorpayCheckoutPrefill,
  RazorpayCheckoutSuccess,
} from '../../../core/models/razorpay-checkout.model';
